import React, { Dispatch } from 'react'
import { useDispatch } from 'react-redux'
import { Button, Form } from 'semantic-ui-react'
import { Field, Form as FinalForm } from 'react-final-form'

import { InputWithSave } from './InputWithSave'
import { postProductAliases, updateBatchAliasAssignments } from '../../redux/actions/productAliases'
import { useSelector } from 'react-redux'
import { AppState } from '../../redux/store'
import { toast } from 'react-toastify'
import { BatchLookupValue } from '../../redux/types/ui'
import { BatchAliasAssignments } from '../../redux/types/productAliases'
import { batchListMoveDown } from '../../redux/actions/ui'

interface Props {
  aliases: string[]
  row: any
  lookupName: string
  isBatchLookup: boolean
  currentBatchId?: string
  matchedName?: string
  requestUuid?: string
}

const handlePostProductAliases = (
  currentBatchId: string | undefined,
  batchLookupValues: BatchLookupValue[],
  batchAliasAssignments: BatchAliasAssignments,
  requestUuid: string | undefined,
  dispatch: Dispatch<any>
) => {
  if (!currentBatchId) {
    return
  }

  const batchSelectedProduct = batchAliasAssignments[parseInt(currentBatchId)].batchSelectedProduct
  const batchLookupValue = batchLookupValues[parseInt(currentBatchId)]

  if (!batchLookupValue.alias && !toast.isActive('post-product-aliases-error')) {
    toast("Alias can't be empty", {
      containerId: 'error',
      toastId: 'post-product-aliases-error',
    })
    return
  }

  if (batchSelectedProduct) {
    if (batchSelectedProduct.removal_status === 'removed') {
      const confirm = window.confirm(
        "The product to which you're assigning an alias is deleted. Continue anyways?"
      )
      if (!confirm) {
        return false
      }
    }
    dispatch(
      postProductAliases({
        id: batchSelectedProduct.id.toString(),
        alias: batchLookupValue.alias.trim(),
        batchId: currentBatchId,
        requestUuid: requestUuid,
      })
    )
    dispatch(batchListMoveDown())
  }
}

export const TableCellProductAlias = (props: Props) => {
  const dispatch = useDispatch()
  const { aliases, row, lookupName, isBatchLookup, matchedName, requestUuid } = props
  const productId = row.values.id
  const isInAliases =
    aliases.findIndex(
      (alias: string) => alias.toLowerCase() === lookupName.trim().toLowerCase()
    ) !== -1
  const { productPhotos } = useSelector((state: AppState) => state.products)
  const { currentBatchId, batchLookupValues } = useSelector((state: AppState) => state.ui)
  const { batchAliasAssignments } = useSelector((state: AppState) => state.productAliases)

  const isConfirmed =
    currentBatchId &&
    row.original.id === batchAliasAssignments[currentBatchId]?.batchSelectedProduct?.id &&
    batchAliasAssignments[currentBatchId]?.isConfirmed

  const isSelected =
    currentBatchId &&
    row.original.id === batchAliasAssignments[currentBatchId]?.batchSelectedProduct?.id

  return isBatchLookup ? (
    isConfirmed ? (
      <Button size="mini" compact content="Confirmed" disabled />
    ) : isSelected ? (
      <div style={{ minWidth: 70 }}>
        <Button
          size="mini"
          compact
          onClick={() =>
            handlePostProductAliases(
              currentBatchId,
              batchLookupValues,
              batchAliasAssignments,
              requestUuid,
              dispatch
            )
          }
          color="green"
          content="Confirm"
        />
      </div>
    ) : (
      <div style={{ minWidth: 70 }}>
        <Button
          size="mini"
          compact
          onClick={() => {
            if (currentBatchId) {
              dispatch(
                updateBatchAliasAssignments({
                  batchId: currentBatchId,
                  batchSelectedProduct: row.original,
                  batchSelectedProductPhotos: productPhotos[row.original.id] || [],
                  batchSelectedProductAliases: aliases,
                  isConfirmed: false,
                })
              )
            }
          }}
          content="Select"
        />
      </div>
    )
  ) : (
    <FinalForm
      onSubmit={async (values: any) => {
        dispatch(
          postProductAliases({
            id: values.product_id,
            alias: values.alias.trim(),
            requestUuid,
          })
        )
      }}
      validate={(values) => {
        if (!values.alias) {
          return { alias: 'Alias cannot be blank' }
        }
      }}
      initialValues={{ product_id: productId }}
      render={({ handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <Field name="alias">
            {(props) => (
              <Form.Field>
                <InputWithSave
                  aliases={aliases}
                  inputProps={{
                    placeholder: matchedName,
                    ...props.input,
                  }}
                  showIsInAliases={isInAliases && !props.meta.dirty}
                  showBtn={props.meta.dirty || isInAliases}
                />
              </Form.Field>
            )}
          </Field>
        </Form>
      )}
    />
  )
}
